initHaendlerForm();

async function getData(plz, haendlersuche) {
  const url = "https://lemon.landpark-bioquelle.de/api/search-dealer?postcode="+plz;
  const resultContainer = haendlersuche.querySelector(".um-haendlersuche__results");
  resultContainer.innerHTML = "";
  haendlersuche.classList.remove("has-flaschenpost")
  haendlersuche.classList.remove("no-dealers")
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const result = await response.json();

    if (result.success) {
      if (result.dealers.length < 1) {
        haendlersuche.classList.add("no-dealers")
      }
      result.dealers.forEach(dealer => {
        let item  = document.createElement("div");
        let title = document.createElement("h3");
        let address = document.createElement("p");
        title.innerHTML = dealer.title;
        address.innerHTML = dealer.street + ", " + dealer.postcode + " " + dealer.city;
        item.appendChild(title);
        item.appendChild(address);
        item.classList.add("haendler-result");
        resultContainer.appendChild(item);
        if (result.hasFlaschenpost) {
          haendlersuche.classList.add("has-flaschenpost")
        } 
      })
    } else {
      const errorMessage = document.createElement("h3");
      errorMessage.innerHTML = result.error;
      errorMessage.classList.add("haendler-error");
      resultContainer.appendChild(errorMessage);
    }

  } catch (error) {
    console.error(error.message);
    const errorMessage = document.createElement("h3");
      errorMessage.innerHTML = "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt.";
      errorMessage.classList.add("haendler-error");
      resultContainer.appendChild(errorMessage);
  }
}

function initHaendlerForm() {
  document.querySelectorAll(".um-haendlersuche__form:not(.initiated)").forEach(element => {
    element.addEventListener("submit", (e) => {
        e.preventDefault();
        getData(element.querySelector("#plz").value, element.parentElement)
    })
    element.classList.add("initiated")
  })
  
}